import { render, staticRenderFns } from "./client-info-detail-modal.vue?vue&type=template&id=143aff41&"
import script from "./client-info-detail-modal.vue?vue&type=script&lang=js&"
export * from "./client-info-detail-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports